export enum BulkOperationsCollectionsTranslation {
    COLLECTIONS_AVAILABLE_OPTIONS = "bulkOperations.collections.availableOptions",
    COLLECTIONS_ADD_TITLE = "bulkOperations.collections.add.title",
    COLLECTIONS_ADD_TITLE_PICKED_OPTIONS = "bulkOperations.collections.add.pickOptions",
    COLLECTIONS_ADD_FAILED_TEXT = "bulkOperations.collections.add.failedText",
    COLLECTIONS_REMOVE_TITLE = "bulkOperations.collections.remove.title",
    COLLECTIONS_REMOVE_TITLE_PICKED_OPTIONS = "bulkOperations.collections.remove.pickedOptions",
    COLLECTIONS_REMOVE_FAILED_TEXT = "bulkOperations.collections.remove.failedText",
}